export const backendUrl = process.env.VUE_APP_BACKEND_API_URL;
export const storageUrl = process.env.VUE_APP_STORAGE_API_URL;
